import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface FormButtonProps {
  /** Button text content */
  children: React.ReactNode;
  /** Whether the button is in a loading state */
  isLoading?: boolean;
  /** Text to show when button is loading */
  loadingText?: string;
  /** Whether the button is disabled */
  disabled?: boolean;
  /** Button variant - defaults to primary */
  variant?: "default" | "outline";
  /** Additional CSS classes */
  className?: string;
  /** Button type */
  type?: "submit" | "button" | "reset";
  /** Click handler */
  onClick?: () => void;
}

/**
 * Form-specific button component with consistent styling across all forms.
 * Features full width, larger padding, rounded corners, and responsive text sizing
 * optimized for mobile and desktop form submissions.
 */
export function FormButton({
  children,
  isLoading = false,
  loadingText,
  disabled = false,
  variant = "default",
  className,
  type = "submit",
  onClick,
}: FormButtonProps) {
  return (
    <Button
      type={type}
      disabled={isLoading || disabled}
      variant={variant}
      onClick={onClick}
      className={cn(
        "w-full py-6 text-base sm:text-lg font-semibold rounded-full",
        className
      )}
    >
      {isLoading && loadingText ? loadingText : children}
    </Button>
  );
}